import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';

import Footer from "../components/footer/Footer";
// import Header from "../components/header/Header";
import Header from "../components/dashboard/header";
import { useNavigate, Link, useLocation } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../api/tmdbApi";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import DataTable from 'react-data-table-component';
import { contentContext } from "../context/contentContext";
import TableLoader from "../components/tableLoader";
import Loader from "../components/loader";
const QuizDetails = () => {
    const navigate = useNavigate();
    const { state } = useLocation();

    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)

    const { quizResult, quizinfo, formData } = state || {};

    const [selected, setSelected] = useState({});
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(false);
    const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState(null);
    const [items, setItems] = useState([]);
    const [success, setSuccess] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(true);
    const [quizzes, setQuizzes] = useState([]);
    const [quizResultData, setQuizResultData] = useState({});

    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    useEffect(() => {
        if (!localStorage.getItem("token1")) {
            navigate("/login");
        }
    }, [])

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [])
    useEffect(() => {

        // Add event listener for popstate to detect when the user presses the back button
        const handlePopState = (event) => {

            navigate("/")
            event.preventDefault();
            console.log("Browser back button pressed.");

        };

        // Initially pushState to allow popstate to fire
        window.history.pushState({}, document.title, window.location.href);

        // Add popstate listener
        window.addEventListener("popstate", handlePopState);

        return () => {
            // Cleanup event listener when component unmounts
            window.removeEventListener("popstate", handlePopState);
        };


    }, []);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };

    const viewResult = (id) => {

        navigate("/viewresult/" + id);

    }


    const columns = [
        {
            name: 'S NO',
            selector: (row, index) => index + 1
        },
        {
            name: 'Image',
            selector: row =>
                row?.files?.[0]
                    ? <div className="myquizimg"> <img src={`${imageCloudfront}${row.files[0].sourcepath.replace(/ /g, "%20")}?auto=compress,format&width=125`} alt="Row Image" /> </div>
                    : null,
        },

        {
            name: 'Quiz Name',
            selector: row => parse(row?.quizname) ?? "",
        },
        {
            name: 'Quiz Type',
            selector: (row) => row?.quizType
        },

        {
            name: 'Participation Date',
            selector: row => row?.created,
            cell: (props) => props?.created ? new Date(props?.created).toLocaleDateString('en-IN', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                // hour: 'numeric',
                // minute: 'numeric',
            }) : "",
            sortable: true,
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },

        {
            name: 'Score',
            selector: row => {
                // console.log("Row data:", row); // Debugging: Inspect the row data
                const correctAnswers = row?.correctAnswers;
                const totalQuestions = row?.totalQuestions;

                if (correctAnswers !== undefined && totalQuestions !== undefined) {
                    return `${correctAnswers}/${totalQuestions}`;
                } else {
                    // console.warn("Missing data for Score:", { correctAnswers, totalQuestions });
                    return ""; // Fallback for missing data
                }
            },
        },


        {
            name: 'Actions',
            cell: (props) => (
                <div className="d-flex align-items-center">
                    {/* Anchor for Result Name */}
                    {props?.quizType === "Competitive" && props?.status !== "COMPLETED" ?
                        <p className="ras">Results will be announced soon</p> : <a
                            className="text-info action-button me-2" // Add spacing using "me-2" (margin-end)
                            onClick={() => viewResult(props?.created)}
                            title="View Result"
                        >
                            <i className="mdi mdi-eye font-size-18"></i> Result
                        </a>
                    }

                    {/* Anchor for Summary Name */}

                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },




    ];


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);



    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     let quizinfo = JSON.parse(localStorage.getItem('q'))
    //     if (quizinfo) {
    //         setQuizData(quizinfo)
    //     }
    //     let quizResult = JSON.parse(localStorage.getItem('qr'))
    //     console.log('quizResult', quizResult)
    //     if (quizResult) {
    //         setQuizResultData(quizResult)
    //         setQuizzes(quizResult?.quiz)
    //     }
    //     // GetQuizInfo()
    // }, []);


    useEffect(() => {
        GetQuizInfo()
    }, [])
    const GetQuizInfo = async () => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.ViewResults();
            setQuizzes(response?.result);
            setcontentLoaded(true)
            setIsLoading(false)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };

    // useEffect(() => {
    //     if (quizData) {
    //         GetQuestionsInfo(quizData)
    //         GetAnswersInfo()
    //     }

    // }, [quizData]);

    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };




    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No quizess found</p>
                </div> </div>
        )
    }
    const handleReports = () => {
        navigate("/viewreports");
    }

    return (
        <main>
            <Header />
            <div className="wrapper quiz_page result quiz_list quiz_details my_quiz">
                {isLoading ? <Loader /> :
                    <>
                        <div className="d-flex align-items-center justify-content-between mt-3">
                            <h4>Quiz</h4>
                            <Link className=" border_btn" to="/"> <span className="material-symbols-outlined mr-10"> arrow_back </span> Back to Home</Link>
                        </div>


                        <div className="question_block">


                            <DataTable key={keyForRerender}
                                // title=""
                                columns={columns}
                                className="table-responsive result_table"
                                keyField='questionid'
                                data={quizzes}
                                direction="auto"
                                highlightOnHover
                                fixedHeaderScrollHeight="300px"
                                // pagination
                                responsive
                                persistTableHead
                                // selectableRowsVisibleOnly
                                striped
                                // selectableRowsHighlight
                                // selectableRows
                                subHeaderAlign="right"
                                defaultSortField="name"
                                subHeaderWra
                                noDataComponent={customNoRecords()}
                                // paginationTotalRows={quizzes?.length}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                // paginationPerPage={rowsPerPage}
                                // paginationDefaultPage={currentPageNew}
                                // paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                sortFunction={customSort}

                                // paginationComponentOptions={{
                                //     rowsPerPageText: 'Per page:',
                                //     rangeSeparatorText: 'of',
                                //     noRowsPerPage: false,
                                //     selectAllRowsItem: false,
                                //     selectAllRowsItemText: 'All',
                                // }}

                                // progressPending={isLoading}
                                progressComponent={<TableLoader />}
                            />




                            {/* <div className="table-responsive ">
                        <table className="table db_table">

                            <thead className="table-light">
                                <tr>
                                    <th width="5%">s no</th>
                                    <th width="35%">scenario</th>
                                    <th width="30%">question</th>
                                    <th width="15%">Selected Answer</th>
                                    <th width="15%">answer</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Verocay bodies are a component of schwannomas and are usually identified in them, but they can also be seen in other neoplasms:</td>
                                    <td> <h4>Verocay bodies are seen in?</h4> </td>
                                    <td><span className="correct">abscess</span></td>
                                    <td>abscess</td>

                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Title: Erythematous papule Definition: A circumscribed, solid elevation of skin with no visible fluid that is reddish (erythematous) in color.</td>
                                    <td> <h4>A 24 year old man comes with complaint of recurrent eruption on face for 6 years. On examination, there are erythematous papules and nodules involving the forehead, cheeks, nose, eyelids and ear rim. Interspersed are numerous deep pitted scars. You have decided to go ahead with a skin biopsy. What do you expect to find?</h4> </td>
                                    <td> <span className="wrong">acantholytic dermatitis herpetiformis (pemphigus herpetiformis)</span> </td>
                                    <td>acantholytic dyskeratoma</td>

                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>The promontory sign is a characteristic appearance of new blood vessels wrapping around and partially entraping pre-existing blood vessels, causing the pre-existing vessels to protrude into the lumen of the new vessels. It can be seen in the following conditions:</td>
                                    <td> <h4>Promontory sign is seen in?</h4> </td>
                                    <td> <span className="correct">acantholytic dyskeratoma</span></td>
                                    <td>acantholytic EB, lethal</td>

                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Verocay bodies are a component of schwannomas and are usually identified in them, but they can also be seen in other neoplasms:</td>
                                    <td> <h4>Verocay bodies are seen in?</h4> </td>
                                    <td> <span className="correct">abscess</span> </td>
                                    <td>abscess</td>

                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Title: Erythematous papule Definition: A circumscribed, solid elevation of skin with no visible fluid that is reddish (erythematous) in color.</td>
                                    <td> <h4>A 24 year old man comes with complaint of recurrent eruption on face for 6 years. On examination, there are erythematous papules and nodules involving the forehead, cheeks, nose, eyelids and ear rim. Interspersed are numerous deep pitted scars. You have decided to go ahead with a skin biopsy. What do you expect to find?</h4> </td>
                                    <td><span className="wrong">acantholytic dermatitis herpetiformis (pemphigus herpetiformis)</span> </td>
                                    <td>acantholytic dyskeratoma</td>

                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>The promontory sign is a characteristic appearance of new blood vessels wrapping around and partially entraping pre-existing blood vessels, causing the pre-existing vessels to protrude into the lumen of the new vessels. It can be seen in the following conditions:</td>
                                    <td> <h4>Promontory sign is seen in?</h4> </td>
                                    <td> <span className="correct">acantholytic dyskeratoma</span> </td>
                                    <td>acantholytic EB, lethal</td>

                                </tr>

                            </tbody>
                        </table>
                    </div> */}




                        </div>
                    </>

                }
            </div>


            <Footer />
        </main>
    );
};

export default QuizDetails;
